import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  LinearProgress,
  Typography,
  Alert,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BulkUpdateProgressBar = ({
  open,
  onClose,
  totalSites,
  completedSites,
  successfulUpdates,
  failedUpdates,
  isProcessing,
  currentBatch,
  totalBatches,
}) => {
  const progress = totalSites > 0 ? Math.round((completedSites / totalSites) * 100) : 0;
  const successCount = successfulUpdates.length;
  const failCount = failedUpdates.length;

  return (
    <Dialog
      open={open}
      onClose={isProcessing ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={isProcessing}
      sx={{
        zIndex: 1300, // Material-UI Dialog default is 1300, ensure it's above everything
      }}
      BackdropProps={{
        sx: {
          zIndex: 1299, // Just below the dialog
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Bulk Update Progress</Typography>
        {!isProcessing && (
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Processing Sites
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {completedSites} / {totalSites} ({progress}%)
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{ height: 8, borderRadius: 4 }}
          />
        </Box>

        {isProcessing && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              Processing batch {currentBatch} of {totalBatches}
            </Typography>
            <Typography variant="caption" color="text.secondary" align="center" display="block">
              Please wait while we update your sites...
            </Typography>
          </Box>
        )}

        {!isProcessing && completedSites > 0 && (
          <Box sx={{ mb: 2 }}>
            <Alert
              severity={
                failCount === 0
                  ? 'success'
                  : failCount > 0 && successCount > 0
                    ? 'warning'
                    : 'error'
              }
              sx={{ mb: 2 }}
            >
              <Typography variant="body2">
                <strong>Update Complete!</strong>
              </Typography>
              <Typography variant="body2">
                ✅ {successCount} successful, ❌ {failCount} failed out of {totalSites} sites
              </Typography>
            </Alert>

            {failCount > 0 && (
              <Typography variant="caption" color="text.secondary">
                Check the browser console for detailed error information.
              </Typography>
            )}
          </Box>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Typography variant="body2" color="primary">
            Successful: {successCount}
          </Typography>
          <Typography variant="body2" color="error">
            Failed: {failCount}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BulkUpdateProgressBar;
